<template>
  <div>
    <footer class="fds-meta footer">
      Contact <a href="mailto: design@feelgood.se">design@feelgood.se</a> for help, questions or feedback
    </footer>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
  .footer {
    padding: 64px 1.5rem;
    text-align: center;
    @media all and (min-width: 1123px) {
      margin-left: 240px;
    }
  }
</style>
